import React from 'react';

interface CategoryAndSubCategoryBreadCrumbProps {
    currentRoot: string;
    categoriesResponse: any;
}

export const CategoryAndSubCategoryPageBreadCrumb = (
    props: CategoryAndSubCategoryBreadCrumbProps
) => {
    const categoryName = props.categoriesResponse?.data?.filteredCategories?.categoryName;
    if (!categoryName) return null;
    return (
        <>
            <a
                className="breadcrumb-link"
                href={`${props.currentRoot}${props.categoriesResponse?.data?.filteredCategories?.categoryAbsoluteSeo}`}
                aria-label={categoryName}
            >
                <span>
                    {categoryName}
                </span>
            </a>
            <span className="back-slash">{'>'}</span>
        </>
    );
};
